// Where an existing seller lands after logging in: checkout for a plan picked on
// mytamilkart.com, the plans page if they signed up, never bought a plan and their
// free trial is over, else `fallback`. A seller still in the free trial has full
// access, and an expired plan isn't "never bought": both land on `fallback`.
import api from "../api/axiosInstance";
import planService from "../services/planService";
import { afterLoginPath } from "./pendingPlan";

export const PLANS_PAGE = "/purchase-plan";
// The redirect waits on this check, so it gives up long before api's 30s default
export const PLAN_CHECK_TIMEOUT_MS = 5000;

// /business/plan/info's answer for a seller with no plan ever: plan_status "none"
// only (a partial answer without plan_id doesn't count)
export const neverBoughtPlan = (info) => !!info && info.plan_status === "none";

// The 14-day free trial, from the created_date that answer carries (planService)
export const inFreeTrial = (info) => !!planService.isInFreeTrial?.(info, info.created_date);

// Pages that aren't a destination to come back to after logging in
const NOT_RETURNABLE = ["/", "/login", "/signup", "/forgot_password"];

// A protected page shows the login form in place when the session is gone
// (App.js), e.g. an order opened from a notification. After logging in the
// seller comes back to it: its path and query, or null on the login pages.
export const returnPathAfterLogin = (location = window.location) => {
    const path = location && location.pathname;
    if (!path || NOT_RETURNABLE.includes(path)) return null;
    return path + (location.search || "");
};

export const loginLandingPath = async (businessId, fallback = "/gift") => {
    const next = afterLoginPath(null);
    if (next) return next;
    // Internal team accounts have full access without a plan
    if (!businessId || planService.isInternalTeam?.(businessId)) return fallback;
    try {
        const { data } = await api.get(`/business/plan/info?business_user_id=${businessId}`, { timeout: PLAN_CHECK_TIMEOUT_MS });
        const info = data?.status === "success" ? (data.result || data.data) : null;
        return neverBoughtPlan(info) && !inFreeTrial(info) ? PLANS_PAGE : fallback;
    } catch (error) {
        // Can't tell: the dashboard, as before
        console.error("Error checking the seller's plan:", error);
        return fallback;
    }
};
